import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useForm, ErrorMessage } from "react-hook-form";
import ReCaptchaV2 from 'react-google-recaptcha';
import withSizes from 'react-sizes';

import { Container, Row, Col } from "deltoid/core/Blocks/BootstrapContainers";
import { Card } from "deltoid/core/OneDashCards";
import { H, Caption, Small } from "deltoid/core/Blocks/Typography";
import Form from "deltoid/core/Form";

import SignUpCMS from "../../features/prismic/SignUpCMS";
import { emailRegex, mobileNumberRegex } from '../../../shared/services/validations';
import AuthManager from '../../../shared/services/AuthManager';

import { fetchUser, forgotPasswordSendLink } from '../../../shared/actions/auth';

import LoginIllustration from "../../../assets/svgs/loginIllustration.svg";
import config from "../../../shared/services/config";
import { UserResponse } from "../../../shared/utils/response";

const ForgotPassword = (props) => {
  const recaptchaRef = useRef(null)
  const { register, handleSubmit, errors, getValues, setError, clearError } = useForm();
  const [isVerified, setIsVerified] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const SITE_KEY = '6LfNTCgTAAAAAJ32bubvkebNUMlR5W_0Z5VmtQ1s';

  useEffect(() => {
    AuthManager.fetchHubTokenResetPassword()
  }, [])

  const onSubmit = async (formData) => {
    const email = getValues('email');
    if (!emailRegex(email) || !mobileNumberRegex(email)) {
      try {
        const res = await forgotPasswordSendLink(props.dispatch, email, AuthManager.getResetScopeToken());
        if (res.status == 200) {
          setIsSuccess(true);
          setIsVerified(false);
          recaptchaRef?.current?.reset?.();
        }
        else {
          if (res?.error == 'No verified email or mobile') {
            if (!emailRegex(email)) {
              const userResponse = await fetchUser(props.dispatch, !emailRegex(email) ? { email } : { mobile: email })
              const user = UserResponse(userResponse.data)
              props.history.push({
                pathname: '/account/mobile_otp',
                state: {
                  ...props.location.state,
                  user,
                  userEmail: email,
                  setPassword: true,
                  isLogin: true,
                }
              });
            } else {
              setIsError('This email or mobile number is not verified, please use register email and try again.');
            }
          } else if (res?.error == 'User not found') {
            setIsError('This email or mobile number does not exist.');
          } else {
            setIsError('Some error occurred. Please try again later');
          }
        }
      } catch (e) {
        setIsError('Some error occurred. Please try again later');
      }
    }
    else {
      setError('email', 'validation', 'Please enter valid email or mobile number')
    }
  };

  const onChange = (data) => {
    setIsVerified(data);
  }

  return (
    <Container fluid className='vector-bg login-max-width-container'>
      <Row>
        {props.isMobile ?
          <Col md={12} className='p-0 d-flex justify-content-between grey-background login-illustration'>
             <span className='pt-4 px-4'>
                <img src={config.get('PAYU_WHITE_LOGO_IMG_URL')} height={40} className='w-auto' />
             </span>
            <LoginIllustration />
          </Col>
          :
          <Col md={6} className='p-0'>
            <SignUpCMS />
          </Col>
        }
        <Col md={5} className={props.isMobile && 'm-0 p-0'}>
          <div className={!props.isMobile && 'login-container mt-5 mx-4'}>
            <Card>
              <H level={5} variant="regular" className="co-heading worksansregular-font">
                Forgot Password
              </H>
              <Caption className='pt-3'>
                Enter your email or mobile number and we will send you a password reset link.
              </Caption>
              <form onSubmit={handleSubmit(onSubmit)} className='px-3 py-3'>
                <Row>
                  <Form.Group className="position-relative pt-4 mb-3">
                    <Form.Label id="email">
                      Email or Mobile Number
                    </Form.Label>
                    <Form.Text
                      id="email"
                      name="email"
                      type="text"
                      ref={register()}
                      onChange={() => clearError()}
                    />
                    <ErrorMessage errors={errors} name="email">
                      {({ message }) => (
                        <Form.Message
                          type="error"
                        >
                          {message}
                        </Form.Message>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Row>
                <Row>
                  <ReCaptchaV2
                    ref={recaptchaRef}
                    sitekey={SITE_KEY}
                    onChange={onChange}
                  />
                </Row>
                <Form.Button
                  type="submit"
                  className="w-100 mt-4 font-weight-bold rounded-btn"
                  disabled={!isVerified}
                >
                  Send Reset Link
                </Form.Button>
                <div className='d-flex justify-content-center pt-4'>
                  <Form.Button
                    variant='underlined'
                    type='button'
                    className="text-bottom-line p-0"
                    onClick={() => {
                      props.history.push({
                        pathname: '/account/signin',
                      });
                    }}
                  >
                    Back to Login
                  </Form.Button>
                </div>
              </form>
              {isSuccess &&
                <div className="co-bg-blue-tint p-3  mb-3 mt-3">
                  <Small>
                    We have sent a reset password link to your email and mobile.
                    Didn’t receive the email? Check email address again or look in your spam folder
                  </Small>
                </div>
              }
              {isError &&
                <div className="co-bg-red-tint p-3  mb-3 mt-3">
                  <Small>
                    {isError}
                  </Small>
                </div>
              }
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};


const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const mapStateToProps = (state) => {
  return {
  };
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});


const Responsive = withSizes(mapSizesToProps)(ForgotPassword);
export default connect(mapStateToProps, mapDispatchToProps)(Responsive);